import axios from 'axios';
import { apiUrl } from './index';

export default {
  getItems(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/pins`,
      params,
    });
  },
  getItem(options = {}) {
    const { id, country } = options;

    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/pins/${country}/${id}`,
    });
  },
  createItem(options = {}) {
    const { country, ...restPin } = options;

    return axios({
      method: 'post',
      url: `${apiUrl}/schedule/pins/${country}`,
      data: restPin,
    });
  },
  updateItem(options = {}) {
    const { id, country, ...restPin } = options;

    return axios({
      method: 'put',
      url: `${apiUrl}/schedule/pins/${country}/${id}`,
      data: restPin,
    });
  },
  removeItem(options = {}) {
    const { id, country } = options;

    return axios({
      method: 'delete',
      url: `${apiUrl}/schedule/pins/${country}/${id}`,
    });
  },
  getPlatforms(options = {}) {
    const { country } = options;

    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/pins/${country}/platforms`,
    });
  },
  getVisibilities(options = {}) {
    const { country } = options;

    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/pins/${country}/visibilities`,
    });
  },
  getPages(options = {}) {
    const { country } = options;

    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/pins/${country}/pages`,
    });
  },
  getPageObjects(options = {}) {
    const { country, page_id, search } = options;
    const params = {
      page_id,
      search,
    };

    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/pins/${country}/page_objects`,
      params,
    });
  },
  getThreads(params) {
    return axios({
      method: 'get',
      url: `${apiUrl}/schedule/threads`,
      params,
    });
  },
};
